import { ActionsReturnTypes, createActions } from 'store/utils';
import { StatusNames } from 'store/entities/timesheet/models/Status';

const GET_EXPENSE_REVIEWER_SHEETS = 'GET_EXPENSE_REVIEWER_SHEETS';
const GET_EXPENSE_REVIEWER_SHEETS_SUCCESS = 'GET_EXPENSE_REVIEWER_SHEETS_SUCCESS';
const GET_EXPENSE_REVIEWER_SHEETS_ERROR = 'GET_EXPENSE_REVIEWER_SHEETS_ERROR';

export const getExpenseReviewerSheets = createActions<StatusNames, void, any,
    typeof GET_EXPENSE_REVIEWER_SHEETS, typeof GET_EXPENSE_REVIEWER_SHEETS_SUCCESS,
    typeof GET_EXPENSE_REVIEWER_SHEETS_ERROR>(
    GET_EXPENSE_REVIEWER_SHEETS, GET_EXPENSE_REVIEWER_SHEETS_SUCCESS, GET_EXPENSE_REVIEWER_SHEETS_ERROR,
);

export type ExpensesApprovalActions = ActionsReturnTypes<typeof getExpenseReviewerSheets>;
